// ============================================================================
// CLEO'S SECRET — Page allowlists
// File: src/lib/valid-pages.js
//
// Single source of truth for both:
//   • VALID_PAGES — the recognised `?page=X` URL parameters
//     consumed by App.jsx's getInitialPageFromUrl.
//   • VALID_RETURN_TO_PAGES — the strict subset of patient destinations
//     that may be specified as a magic-link returnTo target. Validated
//     server-side in api/auth/magic-link-send.js (defence against
//     open-redirect abuse) and double-validated client-side in
//     AuthVerify.jsx after the verify round-trip.
//
// VALID_RETURN_TO_PAGES is intentionally narrower than VALID_PAGES:
//   • Excludes auth-internal pages (login, auth-verify, email-gate) —
//     would create a loop on post-auth redirect.
//   • Excludes privileged routes (admin, clinical, copilot,
//     pathology-review, recommendation-builder) — would allow a magic
//     link sent to a patient to land them on a staff route.
//   • Excludes 'landing' — default fallback already covers it.
//   • Excludes enrolment flow (plan-preview, plan-checkout,
//     enrolment-success) — separate state machine, returnTo doesn't fit.
//
// Note (Phase 4 Session 2 follow-up): the server-side magic-link-send
// endpoint currently duplicates VALID_RETURN_TO_PAGES inline because
// api/* and src/lib/* live in separate import trees (server vs browser
// bundle). Consolidate via a build-time copy or a top-level lib/
// module on next pass. Backlogged in docs/session-5-backlog.md.
// ============================================================================

export const VALID_PAGES = [
  'portal', 'landing', 'about', 'membership', 'stories', 'journal', 'login',
  'auth-verify',
  'clinical', 'admin', 'pathology-review', 'copilot', 'cleo-score', 'program', 'weekly-module', 'retention',
  'email-gate', 'pathology-upload', 'my-results', 'intake', 'scheduler', 'preppack',
  'prep-curriculum', 'prep-module', 'results-reveal', 'consultation-questions', 'cleo-brief',
  'recommendation-builder',
  'plan-preview', 'plan-checkout', 'enrolment-success',
];

export const VALID_RETURN_TO_PAGES = [
  'portal',
  'program',
  'cleo-score',
  'my-results',
  'preppack',
  'prep-curriculum',
  'consultation-questions',
  'cleo-brief',
  'results-reveal',
  'pathology-upload',
];

export function isValidReturnTo(page) {
  return typeof page === 'string' && VALID_RETURN_TO_PAGES.indexOf(page) !== -1;
}
